import AfEventApi from '@/api/afevent';
import LiveApi from '@/api/live';

const MarketingConsentEventApi = {
  /**
   * 대상자 조회
   * @return {Promise<void>}
   */
  marketingConsentInfo: async () => {
    try {
      const response = await AfEventApi.get(
        `/app/marketing-consent/api.php?szWork=checkUser`,
      );
      return response;
    } catch (e) {}
  },
  joinEvent: async () => {
    try {
      const response = await AfEventApi.get(
        `/app/marketing-consent/marketing.php`,
      );
      return response;
    } catch (e) {}
  },
  sendAlimtalk: async () => {
    try {
      const response = await LiveApi.get(
        `/api/sms_event/index.php?work=SMS_EVENT_ALIMTALK`,
      );
      return response;
    } catch (e) {}
  },
};
export default MarketingConsentEventApi;
